export const customEn = {
  StepsTitle: 'Find Hot Grannies Near You'
};

export const customEs = {
    StepsTitle: 'Encuentra abuelas calientes cerca de ti'
};
export const customDa = {
    StepsTitle: 'Find varme bedstemødre nær dig'
};
export const customDe = {
    StepsTitle: 'Finde heiße Omas in deiner Nähe'
};
export const customFi = {
    StepsTitle: 'Löydä kuumia isoäitejä läheltäsi'
};
export const customSv = {
    StepsTitle: 'Hitta heta farmödrar nära dig'
};
export const customFr = {
    StepsTitle: 'Trouvez des mamies sexy près de chez vous'
};
export const customHu = {
    StepsTitle: 'Találj dögös nagymamákat a közeledben'
};

